<span class="sb-text">
  <i [class]="'fa-solid ' + icon"></i>
  <span>{{ message }}</span>
</span>
<button class="sb-button" mat-icon-button (click)="close()">
  <i class="fa-light fa-xmark"></i>
</button>
